export default __webpack_public_path__ + "static/media/sk_headerlogo.80767e51.png";